export default __webpack_public_path__ + "static/media/screen_dropbox_5_1.56bccd7e.png";